import { DefaultDatasetSizeLimiter } from "@/services/license/license-limiters/dataset-size-limiters/default-dataset-size-limiter";

export class VocalRemoverDatasetSizeLimiter extends DefaultDatasetSizeLimiter {
  getUniqueLimit(userId: string): Promise<number | null> {
    return Promise.resolve(null);
  }
}
